export const blockIconsPlacesHolidayVillage = (
	<span className='material-symbols-outlined'>holiday_village</span>
);
